/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Alfred Arthur — Fashion Designer",
  description:
    "Alfred Arthur is a fashion designer and textile artist based in Accra, Ghana. Working in sustainable, staged and avant-garde wear that blends classic elegance with modern innovation and cultural storytelling.",
  og: {
    title: "Alfred Arthur — Fashion Designer & Textile Artist",
    type: "website",
    url: "https://sites.google.com/view/arthuralfred",
  },
};

//Home Page
const greeting = {
  title: "Alfred Arthur",
  logo_name: "Alfred Arthur",
  nickname: "Fashion Designer & Textile Artist",
  subTitle: "Fashion Designer & Textile Artist",
  roleBadge: "Sustainable Fashion · Accra, Ghana",
  favQoute:
    "“To lead the fashion world with innovative designs that redefine style and ignite personal expression.”",
  resumeLink:
    "https://drive.google.com/file/d/1kfIU7ieaWug82N_bAqytSRl8PcXoqpOU/view",
  portfolio_repository: "https://sites.google.com/view/arthuralfred",
  githubProfile: "https://sites.google.com/view/arthuralfred",
};

const socialMediaLinks = [
  {
    name: "Instagram",
    link: "https://www.instagram.com/official_fashey/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "WhatsApp",
    link: "https://wa.me/233249324577",
    fontAwesomeIcon: "fa-whatsapp", // Reference https://fontawesome.com/icons/whatsapp?style=brands
    backgroundColor: "#25D366",
  },
  {
    name: "Gmail",
    link: "mailto:arthuralfred85@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Fashion Design & Garment Construction",
      fileName: "DesignImg",
      skills: [
        "⚡ Concept development, research and mood boards",
        "⚡ Croquis, flats and fashion illustration",
        "⚡ Pattern drafting, draping and toiling",
        "⚡ Tailoring and garment construction",
        "⚡ Staged, conceptual and avant-garde wear",
        "⚡ Styling, art direction and runway presentation",
      ],
      softwareSkills: [
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF9A00",
          },
        },
        {
          skillName: "Adobe Photoshop",
          fontAwesomeClassname: "simple-icons:adobephotoshop",
          style: {
            color: "#31A8FF",
          },
        },
        {
          skillName: "Procreate",
          fontAwesomeClassname: "simple-icons:procreate",
          style: {
            color: "#000000",
          },
        },
      ],
    },
    {
      title: "Textile & Surface Design",
      fileName: "DesignImg",
      skills: [
        "⚡ CAD textile and print design",
        "⚡ Repeat pattern and motif development",
        "⚡ Digital illustration layered with textiles",
        "⚡ Fabric sourcing, dyeing and manipulation",
        "⚡ Screen and digital printing",
        "⚡ Textile sampling and finishing",
      ],
      softwareSkills: [
        {
          skillName: "CorelDRAW",
          fontAwesomeClassname: "simple-icons:coreldraw",
          style: {
            color: "#00A64F",
          },
        },
        {
          skillName: "Canva",
          fontAwesomeClassname: "simple-icons:canva",
          style: {
            color: "#00C4CC",
          },
        },
      ],
    },
    {
      title: "Sustainable & Ethical Fashion",
      fileName: "DesignImg",
      skills: [
        "⚡ Eco-friendly and low-impact material selection",
        "⚡ Upcycling and zero-waste cutting techniques",
        "⚡ Transparent, ethical production practices",
        "⚡ Slow-fashion and made-to-order workflows",
        "⚡ Cultural storytelling through dress",
      ],
      softwareSkills: [],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "Akenten Appiah-Menka University (AAMUSTED)",
      subtitle: "BSc. Fashion Design and Textiles Education",
      logo_path: "images.png",
      alt_name: "AAMUSTED",
      duration: "2021 - 2024",
      descriptions: [
        "Skills Training and Entrepreneurship Development, Kumasi.",
        "⚡ Advanced garment design, pattern cutting and construction",
        "⚡ Textile design, CAD and print development",
        "⚡ Fashion research, portfolio and collection development",
        "⚡ Sustainable and entrepreneurial fashion practice",
        "⚡ Designer of the 'Thorned Enchantment' collection, FADSA Fashion Show 2024",
      ],
      website_link: "https://www.aamusted.edu.gh/",
    },
    {
      title: "Koforidua Technical University",
      subtitle: "HND Fashion Design and Textiles",
      logo_path: "ktu_logo.png",
      alt_name: "KTU",
      duration: "2017 - 2020",
      descriptions: [
        "Where my formal training in fashion began.",
        "⚡ Fundamentals of design, illustration and colour",
        "⚡ Pattern drafting, draping and garment construction",
        "⚡ Textiles, fabric science and surface design",
        "⚡ Launched my first collection on completion",
      ],
      website_link: "https://www.ktu.edu.gh/",
    },
    {
      title: "Ghanata Senior High School",
      subtitle: "Visual Arts — Leatherworks & Fashion Accessories",
      logo_path: "alfred_logo.jpg",
      alt_name: "Ghanata SHS",
      duration: "2013 - 2016",
      descriptions: [
        "⚡ Introduced to the fundamentals of fashion accessories",
        "⚡ Leatherworks, craft and hand construction",
        "⚡ Where my passion for fashion first took shape",
      ],
    },
  ],
};

const certifications = {
  certifications: [],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Collections, Studio Work and Training",
  description:
    "My journey in fashion began in Accra, inspired by the city's rich fashion heritage. From Visual Arts and leatherworks at Ghanata Senior High School, to Fashion Design and Textiles at Koforidua Technical University, to collection work at AAMUSTED, I have built a practice around designs that blend classic elegance with modern innovation — grounded in sustainability, ethical production and storytelling through dress.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Design Work",
      work: true,
      experiences: [
        {
          title: "Founder & Lead Designer",
          company: "Fashey (@official_fashey)",
          company_url: "https://www.instagram.com/official_fashey/",
          logo_path: "alfred_logo.jpg",
          duration: "2020 - Present",
          location: "Accra, Ghana",
          description:
            "My own label, built after launching my first collection. Designs blend classic elegance with modern innovation, with a commitment to eco-friendly materials and transparent production.",
          color: "#5D2A42",
          raw_html:
            "<div> <ul>" +
            "<li>Design and produce made-to-order and staged wear for clients and shows</li>" +
            "<li>Lead every stage from concept research and illustration to pattern, construction and finishing</li>" +
            "<li>Style and art-direct shoots and runway presentations</li>" +
            "<li>Source sustainable fabrics and apply upcycling and zero-waste techniques</li>" +
            "</ul></div>",
        },
        {
          title: "Collection Designer",
          company: "AAMUSTED — Fashion & Design Students' Association (FADSA)",
          company_url: "https://www.aamusted.edu.gh/",
          logo_path: "projects/thorned-enchantment/final_03.jpg",
          duration: "2024",
          location: "Kumasi, Ghana",
          description:
            "Designed and produced 'Thorned Enchantment', a sustainable staged-wear collection shown at the FADSA Fashion Show 2024 under the theme 'Fashioning a Sustainable Future'.",
          color: "#8D697A",
          raw_html:
            "<div> <ul>" +
            "<li>Developed the concept from the thorns of the Silk Floss Tree (Ceiba speciosa) and the Spiny Puff Ball Mushroom</li>" +
            "<li>Produced inspiration, mood, style and fabric boards, croquis and technical flats</li>" +
            "<li>Designed and printed original CAD textiles for the collection</li>" +
            "<li>Constructed thorn-inspired garments, accessories and a portfolio bag</li>" +
            "</ul></div>",
        },
      ],
    },
    {
      title: "Education & Training",
      experiences: [
        {
          title: "Fashion Design & Textiles Trainee",
          company: "Koforidua Technical University",
          company_url: "https://www.ktu.edu.gh/",
          logo_path: "ktu_logo.png",
          duration: "2017 - 2020",
          location: "Koforidua, Ghana",
          description:
            "Three years of formal training in fashion design and textiles. On completion I launched my first collection, which drew a strong and encouraging response.",
          color: "#0879bf",
        },
        {
          title: "Visual Arts Student — Leatherworks",
          company: "Ghanata Senior High School",
          company_url: "",
          logo_path: "alfred_logo.jpg",
          duration: "2013 - 2016",
          location: "Dodowa, Ghana",
          description:
            "Introduced to the fundamentals of fashion accessories through leatherworks, which grew into a passion for fashion design.",
          color: "#fc1f20",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Collections",
  description:
    "Selected design work — concept, textile development, construction and runway.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Collections",
  description: "Selected design work.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "thorned-enchantment",
      name: "Thorned Enchantment",
      folder: "thorned-enchantment",
      createdAt: "2024-06-01T00:00:00Z",
      description:
        "A sustainable staged-wear collection built on the theme 'Fashioning a Sustainable Future'. Inspired by the thorns of the Silk Floss Tree (Ceiba speciosa) and the Spiny Puff Ball Mushroom, it uses the thorn as a metaphor for resilience — and for the obstacles of fashion education that, once overcome, lead to growth. Original CAD textiles, thorn-inspired silhouettes and accessories. Shown at the AAMUSTED FADSA Fashion Show 2024.",
      url:
        "https://sites.google.com/view/arthuralfred/portfolio/thorned-enchantment",
      logo_path: "thorned-enchantment/final_03.jpg",
      screenshots: [
        "final_02.jpg",
        "final_03.jpg",
        "final_01.jpg",
        "final_04.jpg",
        "final_05.jpg",
        "final_06.jpg",
        "croquis_01.jpg",
        "croquis_02.jpg",
        "inspiration.jpg",
        "mood.png",
        "style_board.jpg",
        "fabric_board.png",
        "color_palette.png",
        "textile_cad_01.jpg",
        "textile_cad_02.jpg",
        "textile_print_01.png",
        "textile_print_02.jpg",
        "accessory_01.jpg",
        "accessory_02.jpg",
        "accessory_03.jpg",
        "accessory_04.jpg",
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Get in Touch",
    profile_image_path: "alfred_portrait.jpg",
    description:
      "Available for commissions, collaborations, styling and shows. Send me a message and I typically reply within 24 hours — let's talk about your next piece.",
  },
  blogSection: {
    title: "Alfred Arthur",
    subtitle: "Tel: +233 24 932 4577",
    link: "mailto:arthuralfred85@gmail.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Studio",
    subtitle: "Accra, Ghana",
    locality: "Accra",
    country: "GH",
    region: "Greater Accra",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+233 24 932 4577",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
